import Image from 'next/image';
import { useRouter } from 'next/router';

import { Frequency } from '../../const/newsletter-meta';

import SVGCheckCircle from './svg-check-circle';

const NewsletterCard = ({
    title,
    description,
    href,
    imageUrl,
    handleCheckMarkClick,
    isChecked,
    frequency,
}: {
    title: string;
    description: string;
    href: string;
    imageUrl: string;
    handleCheckMarkClick: () => void;
    isChecked: boolean;
    frequency: Frequency;
}) => {
    const router = useRouter();

    const handleNavigate = () => {
        router.push(href);
    };

    return (
        <div className="flex flex-col w-full border p-8 lg:p-10 gap-2">
            <div className="flex justify-between items-start">
                <div className="flex flex-col gap-2">
                    <Image
                        src={imageUrl}
                        alt={title}
                        width={100}
                        height={100}
                        onClick={handleNavigate}
                        style={{ cursor: 'pointer' }}
                    />
                    <div className="flex justify-start items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
                            <path
                                d="M4.33333 3.66667V1M9.66667 3.66667V1M3.66667 6.33333H10.3333M2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V3.66667C13 2.93029 12.403 2.33333 11.6667 2.33333H2.33333C1.59695 2.33333 1 2.93029 1 3.66667V11.6667C1 12.403 1.59695 13 2.33333 13Z"
                                stroke="#110B29"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <p className="text-xs lg:text-sm tracking-[1.25px] uppercase"> {frequency} </p>
                    </div>
                </div>
                <SVGCheckCircle isChecked={isChecked} handleClick={handleCheckMarkClick} />
            </div>
            <div className="flex flex-col justify-start items-start gap-2">
                <button
                    className="text-2xl lg:text-3xl  font-bold tracking-[0.25px] text-left"
                    onClick={handleNavigate}
                >
                    {title}
                </button>
                <p className="text:sm lg:text-md">{description}</p>
            </div>
        </div>
    );
};

export default NewsletterCard;
